import { render, staticRenderFns } from "./TaskDetail.vue?vue&type=template&id=347c775c&scoped=true"
import script from "./TaskDetail.vue?vue&type=script&lang=js"
export * from "./TaskDetail.vue?vue&type=script&lang=js"
import style0 from "./TaskDetail.vue?vue&type=style&index=0&id=347c775c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347c775c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('347c775c')) {
      api.createRecord('347c775c', component.options)
    } else {
      api.reload('347c775c', component.options)
    }
    module.hot.accept("./TaskDetail.vue?vue&type=template&id=347c775c&scoped=true", function () {
      api.rerender('347c775c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/taskExamine/task/components/TaskDetail.vue"
export default component.exports